// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"49720bc3","455":"340c2fba"}[chunkId] + ".chunk.js";
};